import { useCallback } from 'react'
import compact from 'lodash/compact'
import { useLastPhoneCallLazyQuery } from '../graphql/LastPhoneCall'
import { ILastPhoneCallFragment } from '../graphql/LastPhoneCallFragment'

export interface IUseLastPhoneCallResult {
  fetchLastPhoneCall: () => void
  hasFetchedLastPhoneCall: boolean
  isFetchingLastPhoneCall: boolean
  lastPhoneCall?: ILastPhoneCallFragment
}

export const useLastPhoneCall = (toPhoneNumber: string): IUseLastPhoneCallResult => {
  const [fetch, { called, data, loading }] = useLastPhoneCallLazyQuery({
    variables: {
      toPhoneNumber,
    },
  })

  const { phoneCalls } = data ?? {}
  const { nodes } = phoneCalls ?? {}
  const [lastPhoneCall] = compact(nodes) ?? []

  /**
   * Fetch the last phone call only once.
   */
  const fetchLastPhoneCall = useCallback(() => {
    if (!called) {
      fetch()
    }
  }, [fetch, called])

  return {
    fetchLastPhoneCall,
    hasFetchedLastPhoneCall: !loading && Array.isArray(nodes),
    isFetchingLastPhoneCall: loading,
    lastPhoneCall,
  }
}
